import React from 'react';
import _Rooms from '../components/_Rooms';
import MainLayout from '../layout/MainLayout';

const RoomsPage = () => {
  return (
    <MainLayout>
        <_Rooms/>
    </MainLayout>
  )
}

export default RoomsPage